// src/components/AnimatedPage.js
import { motion } from 'framer-motion';

export const pageVariants = {
  initial: { opacity: 0, y: 22, scale: 0.990, filter: 'blur(10px)' },
  animate: {
    opacity: 1, y: 0, scale: 1, filter: 'blur(0px)',
    transition: {
      duration: 0.52,
      ease: [0.22, 1, 0.36, 1],
      staggerChildren: 0.06,
      delayChildren: 0.05,
    },
  },
  exit: {
    opacity: 0, y: -14, scale: 0.994, filter: 'blur(6px)',
    transition: { duration: 0.28, ease: [0.4, 0, 1, 1] },
  },
};

// Re-usable child variants – import these in list pages for stagger effect
export const itemVariants = {
  initial: { opacity: 0, y: 16, scale: 0.97 },
  animate: {
    opacity: 1, y: 0, scale: 1,
    transition: { duration: 0.42, ease: [0.22, 1, 0.36, 1] },
  },
};

// Spring-based modal enter (import in modal overlays)
export const modalVariants = {
  initial: { opacity: 0, scale: 0.92, y: 24 },
  animate: {
    opacity: 1, scale: 1, y: 0,
    transition: { type: 'spring', stiffness: 340, damping: 28 },
  },
  exit: {
    opacity: 0, scale: 0.94, y: 16,
    transition: { duration: 0.22, ease: [0.4, 0, 1, 1] },
  },
};

const AnimatedPage = ({ children }) => (
  <motion.div
    variants={pageVariants}
    initial="initial"
    animate="animate"
    exit="exit"
  >
    {children}
  </motion.div>
);

export default AnimatedPage;